import { getNotificationState } from 'common/header/notifications/hooks/mappers/impl/shared';
import {
  type MappedNotification,
  type NotificationMapper,
  type NotificationMapperOptions
} from 'common/header/notifications/Notifications.types';

export const workdayOrgSyncMapper: NotificationMapper = (notification, options) => {
  return {
    ...notification,
    ...getTitle(notification, options)
  };
};

const getTitle = (notification: MappedNotification, options: NotificationMapperOptions) => {
  const state = getNotificationState(notification.status);
  let title = notification?.title ?? '';
  let description = notification?.description ?? '';
  if (state.isReady) {
    description = options.intl.workdaySuccessDescription;
  } else if (state.inProgress) {
    description = options.intl.workdayInProgressDescription;
  } else {
    description = state.isError ? options.intl.workdayFailureDescription : '';
  }
  title = options.intl.workdayTitle;
  return { title, description };
};
